<template>
  <div class="sidebar">
    <el-scrollbar style="height: 100%" wrapStyle="overflow-x: hidden;">
      <el-menu
        router
        :default-active="defaultActive"
      >
        <template v-for="(menu, index) in myMenu">
          <el-submenu
            v-if="menu.Children"
            :index="`${index}`"
            :show-timeout="0"
            :hide-timeout="200"
            :key="index"
            :popper-append-to-body="false"
          >
            <template slot="title">
              <i class="fa fa-fw" :class="`fa-${menu.Icon}`"></i>
              <span>{{ menu.Title }}</span>
            </template>
            <el-menu-item
              v-for="menuChild in menu.Children"
              :index="menuChild.Name"
              :route="{ name: menuChild.Name }"
              :key="menuChild.Name"
            >
              <i class="fa fa-fw" :class="`fa-${menuChild.Icon}`"></i>
              <span>{{ menuChild.Title }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item
            v-else
            :index="menu.Name"
            :route="{ name: menu.Name }"
            :key="menu.index"
          >
            <i class="fa fa-fw" :class="`fa-${menu.Icon}`"></i>
            <span>{{ menu.Title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userMenu: [],
      defaultActive: null,
    };
  },
  computed: {
    menus() {
      return this.$store.state.Auth.user.Menu || [];
    },
    cperms() {
      const arr=[];
      this.$store.state.Auth.user.Permissions.forEach((perm) => {
        if (arr.indexOf(perm.Obj)===-1){
          arr.push(perm.Obj);
        }
      });
      // return this.$store.state.Auth.user.Permissions || [];
      return arr
    },
    myMenu() {
      const iterator = (ms) => {
        const nms = [];
        ms.forEach((m) => {
          if (m.Perms && m.Perms !== [] && _.intersection(this.cperms, m.Perms).length === 0) {
            return;
          }
          if (m.Children) {
            const ncms = iterator(m.Children);
            if (ncms.length > 0 && _.intersection(this.cperms, m.Perms).length === 0) {
              nms.push({ ...m, Children: ncms });
            }
          } else {
            nms.push(m);
          }
        });
        return nms;
      };
      return iterator(this.menus);
    },
    // 在菜单中的菜单名称列表
    allMenuNames() {
      const list = [];
      const iterator = (ms) => {
        if (ms) {
          ms.forEach((m) => {
            if (m.children) {
              iterator(m.children);
            } else {
              list.push(m.name);
            }
          });
        }
      };
      iterator(this.menuList);
      return list;
    },
    // 所有route定义， path => name
    allValidRoutes() {
      const map = {};
      const iterator = (ms) => {
        ms.forEach((m) => {
          if (m.children) {
            iterator(m.children);
          }
          if (m.name) {
            map[`/${m.path}`] = m.name;
          }
        });
      };
      iterator([_.find(this.$router.options.routes, ['path', '/'])]);
      return map;
    },
  },
  watch: {
    $route: {
      handler(v) {
        // 如果菜单栏没找到这个name,并且长度大于2个，则递归去找
        if (
          this.allMenuNames.indexOf(v.name) === -1
          && v.path.split('/').length > 2
        ) {
          this.getParentRouter(v.path);
        } else {
          this.defaultActive = v.name;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onSelectRoute(routeName) {
      const route = this.getRouteByName(routeName);
      if (route && route.meta && route.meta.commitName) {
        this.$store.commit(route.meta.commitName);
      }
    },
    getRouteByName(name, routes = null) {
      if (!routes) {
        /* eslint-disable no-param-reassign */
        routes = this.$router.options.routes;
      }
      let route = null;
      _.forEach(routes, (r) => {
        if (r.name === name) {
          route = r;
          return;
        }
        if (r.children) {
          route = this.getRouteByName(name, r.children);
        }
      });
      return route;
    },
    // 递归去找上一层地址
    getParentRouter(path) {
      path.split('/');
      // const p = path.split('/');
      // let str = '';
      // // 截取从0到倒数第二个的数组（方法不包括end的数组元素），然后加入‘/’
      // str = _.join(_.slice(p, 0, p.length - 1), '/');
      // // 如果为空了，不要继续循环下去了，直接默认高亮首页
      // if (str === '') {
      //   this.defaultActive = this.allMenuNames[0];
      // } else if (this.allValidRoutes[str] === undefined) {
      //   this.getParentRouter(str);
      // } else {
      //   this.defaultActive = this.allValidRoutes[str];
      // }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
$main-content-padding: 15px;
$sidebar-width: 180px !default;
$sidebar-width-collapsed: 50px !default;
$sidebar-item-height: 50px !default;
$header-height: 50px !default;
.sidebar {
  --color-sidebar-bg: #f2f2f2;
  --color-sidebar-bg-lighter: #fff;
  --color-sidebar-active-bg: #23a2d8;
  --color-sidebar-active-fg: #ffffff;
  --color-sidebar-fg: #4d4d4d;
  position: fixed;
  top: $header-height;
  left: 0;
  bottom: 0;
  width: $sidebar-width;
  min-height: calc(100vh - #{$header-height});
  padding-top: 0;
  font-size: 14px;
  transition: all 0.5s ease;
  color: var(--color-sidebar-fg, #333);
  background-color: var(--color-sidebar-bg, #fff);
  box-shadow: 10px 0 10px -10px rgba(0, 0, 0, 0.2);
  .sidebar-toggler {
    position: relative;
    line-height: 3em;
    cursor: pointer;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    i {
      transition: all 0.5s;
    }
  }
  // 复写 element
  .el-menu {
    border-right: none;
    background-color: transparent;
    i.fa {
      margin-right: 3px;
      color: var(--color-sidebar-fg, #303133);
    }
    .el-menu-item,
    .el-submenu__title {
      color: var(--color-sidebar-fg, #303133);
      min-width: auto;
      padding: 0 0 0 15px !important;
      height: $sidebar-item-height;
      line-height: $sidebar-item-height;
      &:hover,
      &.is-active {
        background: var(--color-sidebar-active-bg, #f0f0f0);
        color: var(--color-sidebar-active-fg, #333333);
        i.fa {
          color: var(--color-sidebar-active-fg, #333333);
        }
      }
    }
    .el-submenu {
      .el-menu {
        background: var(--color-sidebar-bg-lighter, #ffffff);
      }
      .el-menu-item {
        padding: 0 0 0 30px !important;
        &:hover,
        &.is-active {
          background: var(--color-sidebar-active-bg, #f0f0f0);
          color: var(--color-sidebar-active-fg, #333333);
        }
      }
    }
  }
  &.collapsed {
    width: $sidebar-width-collapsed;
    .sidebar-toggler {
      i {
        transform: rotate(-180deg);
      }
    }
  }
}
.menu {
  background: #f2f2f2;
  position: fixed;
  width: 180px;
  height: 100%;
  box-shadow: 0 1px 1px #ccc;
  > .container {
    margin: 0 auto;
  }
  .navigation-menu {
    display: block;
    i.fa-fw {
      margin-right: 0.25em;
    }
    .el-menu--popup-bottom-start {
      margin-top: 0;
    }
    .el-menu-item,
    .el-submenu .el-submenu__title {
      background: #f2f2f2;
      text-align: left;
      height: $topbar-menu-height;
      line-height: $topbar-menu-height;
      outline: none;
    }
  }
}
</style>
